import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import cls from '../styles.module.scss'

export const TextContentEl = () => {
    return (
        <HighlightedText
            text="μπόνους 325% + 400 δωρεάν περιστροφές "
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['400']}
            className={cls.text}
        />
    )
}
